import React from 'react';
import withIcon from '../utilities/withIcon';

const IconAirplane = () => {
  return (
    <g>
      <path d="m15.89 1.1893-.001-.0092a.6981.6981 0 0 0 -.1324-.2468c-.0128-.0154-.0311-.0222-.0449-.0362-.0089-.009-.01-.0225-.02-.0311-.0151-.0138-.0367-.0147-.0527-.0271a.6751.6751 0 0 0 -.229-.1178.66.66 0 0 0 -.08-.0235.6882.6882 0 0 0 -.33.0224l-.01.0007-14.1487 4.9079a1.12 1.12 0 0 0 -.1929 2.0278l4.0235 2.3215.0009 4.0863a1.1819 1.1819 0 0 0 .7319 1.1543 1.182 1.182 0 0 0 1.3369-.2925l2.2522-2.4545 1.97 1.1366a1.4349 1.4349 0 0 0 2.1074-.8906l2.8262-11.1641c.0035-.0141-.0036-.0278-.0009-.042a.691.691 0 0 0 -.0065-.3221zm-4.07 2.1121-6.5134 5.4262-3.4273-1.9776zm-5.7478 10.2838v-2.7994l1.68.9691zm5.5913-1.19-5.0643-2.9219 7.4014-6.1659z" />
    </g>
  );
};

export default withIcon(IconAirplane);
